export default {
  sm: `
  Hosting and operating a 
  humongous amount of big data 
  with physical servers requires 
  massive time and high costs. 
  So Naver offers flexible cloud 
  platform service which enables 
  IT resources to be shared and 
  virtualized freely.   
  `,
  md: `
  Hosting and operating a 
  humongous amount of big data 
  with physical servers requires 
  massive time and high costs. So 
  Naver offers flexible cloud platform 
  service which enables IT resources 
  to be shared and virtualized freely.    
  `,
  lg: `
  Hosting and operating a humongous 
  amount of big data with physical 
  servers requires massive time and 
  high costs. So Naver offers flexible 
  cloud platform service which 
  enables IT resources to be shared 
  and virtualized freely.     
  `,
  xxl: `
  Hosting and operating a humongous 
  amount of big data with physical servers 
  requires massive time and high costs.
  So NAVER offers flexible cloud platform 
  service which enables IT resources to
  be shared and virtualized freely.      
  `,
};
